import { format, formatDistanceToNow, parse, parseISO } from "date-fns";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useHistory, withRouter } from "react-router-dom";
import { compose } from "redux";
import { apiRequest } from "../../helpers";
import { getSpecificStudyModules } from "../../redux/actions";
import { studyModulesData } from "../../redux/selectors";
import N from '../../assets/images/N.png'
import E from '../../assets/images/E.png'
import C from '../../assets/images/C.png'

const NotificationDropDown = (props) => {
  const history = useHistory();
  const [studyModuleRes, setStudyModuleRes] = useState();
  const [studyModule, setStudyModule] = useState();

  const { closeSide, notificationList, loading, studyModulesData, getSpecificStudyModules } = props;

  useEffect(() => {
    getSpecificStudyModules();
  }, []);

  const removeImagesFromContent = (content) => {
    const contentWithoutImages = content.replace(/<img[^>]*>/g, '');

    return contentWithoutImages.slice(0, 20);
  }

  function extractFirstImageFromContent(content) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(content, 'text/html');
    const imgElement = doc.querySelector('img');
    
    return imgElement ? imgElement.getAttribute('src') : null;
  }


  const handleNotificationClick = (selected) => {
    let obj = selected.module;
    if (studyModulesData?.length > 0) {
      for (let i = 0; i < studyModulesData.length; i++) {
        if (
          parseInt(selected?.module?.study_module) ===
            parseInt(studyModulesData[i].id) ||
          parseInt(selected?.module?.id) === parseInt(studyModulesData[i].id)
        ) {
          setStudyModule(studyModulesData[i].slug);
          if (selected.module.type === "StudyModule") {
            localStorage.setItem("study-module", selected.module.slug);
            localStorage.setItem("study-module_id", selected.value.id);
            history.push({
              pathname: `/study-module/${selected.module.slug}`,
              state: { obj },
            });
          } else if (selected.module.type === "Note") {
            history.push({
              pathname: `/${studyModulesData[i].slug}/notes/${selected.module.slug}`,
              state: { obj },
            });
          } else if (selected.module.type === "Essay") {
            history.push({
              pathname: `/${studyModulesData[i].slug}/model-essays/${selected.module.slug}`,
              state: { obj },
            });
          } else if (selected.module.type === "CaseStudy") {
            history.push({
              pathname: `/${selected.module.slug}/`,
              state: { obj },
            });
          } else if (selected.module.type === "TutorialVideo") {
            window.location.href = selected.module.url;
          } else if (selected.value.type === "Quiz") {
            history.push({
              pathname: `/quiz/${selected.module.slug}/`,
              state: {
                state: selected.module.slug,
                value: studyModulesData[i].slug,
              },
            });
          } else if (selected.module.type === "FlashCard") {
            history.push({ pathname: `/${studyModulesData[i].slug}/flashcards` });
          }
        }
      }
    }

    closeSide(false);
  };

  const handleTitleEllipsis = (title) => {
    if(title?.length > 20){
      return title?.substring(0, 20) + "..."
    } else {
      return title
    }
  }

  return (
    <div>
      <div class="side-bar mr-20" id="sideBarMen" >
        <div className="sideBarSubSec">
        <div class="close-icon" onClick={() => closeSide(false)}>
          &times;
        </div>
        {notificationList?.length > 0 ? (
          notificationList?.map((item) => {
            const providedTimestamp = parseISO(item?.created_at);
            const timeAgo = formatDistanceToNow(providedTimestamp, {
              addSuffix: true,
            });

            return (
              <div
                className="chat-side cursor-pointer"
                onClick={() => {
                  handleNotificationClick(item);
                  closeSide(false);
                }}
              >
                <div className="for-txt chatSideLeft">
                  <div className="head flex chatSLImgSec">
                  <img src={item?.module?.type === 'Note' ? N : item?.module?.type === 'Essay' ? E : C} alt="img" className="flex-auto" style={item?.module?.type === 'Note' || item?.module?.type === 'Essay' ? {width: '10px', height: '42px', display: 'flex'} : item?.module?.type === 'CaseStudy' ? {width: '10px', height: '42px', display: 'flex'} : {width: '20px', height: '20px', display: 'flex'}} />
                    
                  </div>
                </div>
                <div className="for-txt mt-2 chatSideRight">
                  <div>
                  <h2>{handleTitleEllipsis(item?.module?.title)}</h2>
                    <p
                      className="text-gray-600 text-right flex-auto"
                      style={{ color: "gray" }}
                    >
                      {timeAgo}
                    </p>
                  </div>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: item?.module?.content
                        ? removeImagesFromContent(item.module.content)
                        : item?.module?.description
                        ? removeImagesFromContent(item.module.content)
                        : "",
                    }}
                  ></p>
                </div>
              </div>
            );
          })
        ) : loading === true ? (
          <div className="text-center mt-32">
            <svg
              aria-hidden="true"
              role="status"
              className="inline w-8 h-8 mr-3 text-black animate-spin"
              viewBox="0 0 100 101"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                fill="#E5E7EB"
              />
              <path
                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                fill="currentColor"
              />
            </svg>
          </div>
        ) : (
          <div className="text-center mt-32">
            <p>No Notifications</p>
          </div>
        )}
      </div>
    </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  studyModulesData: studyModulesData(state),
});

const mapDispatchToProps = (dispatch) => ({
  getSpecificStudyModules: () => dispatch(getSpecificStudyModules()),
});

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(NotificationDropDown);
